import { Injectable } from '@angular/core';
import { WindowOpenerService } from '@services/window-opener/window-opener.service';
import { Destination } from '../../schema/destination';
import { GoogleMapsProviderService } from '../google-maps-provider/google-maps-provider.service';

@Injectable({
  providedIn: 'root'
})
export class SygicProviderService extends GoogleMapsProviderService {
  constructor(private readonly window: WindowOpenerService) {
    super(window);
  }

  navigateTo(destination: Destination) {
    this.transformDestination(destination);
    this.window.system(`com.sygic.aura://coordinate%7C${destination.location.x}%7C${destination.location.y}%7Cdrive`);
  }
}
